import React from "react";
import DBRetentionSection from "../logsRetention/DBRetentionSection"
import LogsRetentionSection from "../logsRetention/LogsRetentionSection"

export default function RetentionSection() {
  return (
    <>
      <div className="oct_settings-section-header" >
        <h3>Logs Retention</h3>
      </div>

      <div className="oct_settings-section-body py-3">
        <DBRetentionSection />
        <div className="oct_settings-divider">
          <LogsRetentionSection />
        </div>
      </div>
    </>
  );
}
